import React, { useState, useEffect, useRef } from "react";

//useForm
import {
  useForm
} from "react-hook-form";

//API
import api from "../services/api";

//Feather icons
import {
  X,
} from "react-feather";

//components
import Popup from "./Popup";
import Input from "./Input";
import Button from "./Button";

//Auth
import { useAuth } from "../providers/auth";
import Spinner from "./Spinner";

//Sweet alert
import Swal from "sweetalert2";
import LoadingCenter from "./LoadingCenter";

export default function PopupChatTags(props) {
  const { title, info, trigger, setTrigger, editInfoAdmin, chat } = props;

  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const { user } = useAuth();

  const input = useRef(null);

  const [customerTags, setCustomerTags] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTags, setSearchTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [keyDownTerm, setKeyDownTerm] = useState(null);

  async function handleAddExistingTagToCustomer(id) {

    try {
      setLoading(true);

      const response = await api.post("/tags/" + id, { user_id: info.id }, { headers: { "Authorization": "Bearer " + user.token } });

      if (response.data.error) {
        let icon = "error";
        let title = "Erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      }

      if (!response.data.error) {
        let icon = "success";
        let title = "Sucesso";
        let text = response.data.message;

        openAlert(icon, title, text);

        setCustomerTags([...customerTags, response.data.tag]);

        let arrTags = searchTags.filter(tag => tag.id !== id);
        setSearchTags(arrTags);
      }

      console.log(response.data);
    } catch (error) {
      let icon = "error";
      let title = "Ocorreu um erro";
      let text = "Erro interno do servidor.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmitTag() {
    if (searchTerm !== "") {
      try {
        setLoading(true);
        setCustomerLoading(true);

        const response = await api.post("/tags/customer?id=" + info.id, { name: searchTerm }, { headers: { "Authorization": "Bearer " + user.token } });

        if (response.data.error) {
          let icon = "error";
          let title = "Ocorreu um erro";
          let text = response.data.message;

          openAlert(icon, title, text);
        }

        if (!response.data.error) {
          let icon = "success";
          let title = "Sucesso";
          let text = response.data.message;

          openAlert(icon, title, text);

          setCustomerTags([...customerTags, response.data.tag]);
        }

      } catch (error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = "Erro interno do servidor.";

        openAlert(icon, title, text);
      } finally {
        setLoading(false);
        setCustomerLoading(false);
      }
    }
  }

  async function handleRemoveTag(id) {

    try {
      setCustomerLoading(true);

      const response = await api.post("/user_tags/remove?user_id=" + info.id + "&tag_id=" + id, { headers: { "Authorization": "Bearer " + user.token } });

      if (!response.data.error) {
        let icon = "success";
        let title = "Sucesso";
        let text = response.data.message;

        openAlert(icon, title, text);

        //excluindo a tag do array
        const newTags = customerTags.filter(tag => tag.id !== id);
        setCustomerTags(newTags);

        editInfoAdmin();
      }

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      }
    } catch (error) {
      let icon = "error";
      let title = "Ocorreu um erro";
      let text = "Erro interno do servidor.";

      openAlert(icon, title, text);
    } finally {
      setCustomerLoading(false);
    }
  }

  async function handleSearchChatTags() {

    if (keyDownTerm) {
      if (keyDownTerm.key === "Backspace" && searchTerm === "") {

      } else {
        try {
          setLoading(true);

          const response = await api.get("/tags/search?query=" + searchTerm, { headers: { "Authorization": "Bearer " + user.token } });

          setSearchTags(response.data);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      }
    }
  }

  async function handleFetchAllTags() {

    //se possui os dados do chat
    if (chat.current !== null) {
      try {
        setCustomerLoading(true);

        //chama todos os chats do admin com o cliente
        const response = await api.get("/tags/user?user_id=" + chat.current.id, { headers: { "Authorization": "Bearer " + user.token } });

        //se não der erro ele continua
        if (!response.data.error) {
          setCustomerTags(response.data);
        } else {
          //console.log(response.data.message);
        }

      } catch (e) {
        console.log("Erro:", e);
      } finally {
        setCustomerLoading(false);
      }
    }
  }

  useEffect(() => {
    handleFetchAllTags();
  }, [trigger]);

  useEffect(() => {
    const writeDelay = setTimeout(() => {
      handleSearchChatTags();

      if (input.current !== null) {
        input.current.focus();
      }
    }, 1500);

    return () => clearTimeout(writeDelay);
  }, [searchTerm]);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  return (
    <Popup title={title} trigger={trigger} setTrigger={setTrigger} >
      <form onSubmit={handleSubmit(handleSubmitTag)}>
        <div className="sm-body">
          <span className="popup-label">Tags do seu cliente</span>

          {customerLoading && <LoadingCenter />}

          {!customerLoading && customerTags.map((tag, index) => {
            return (
              <div key={index} className="tag-delete">
                <div className="tag-delete-inner">
                  <span>#{tag.name}</span>
                  <button className="btn-tag-delete" onClick={() => handleRemoveTag(tag.id)}>
                    <X size={18} />
                  </button>
                </div>
              </div>
            );
          })}

          <div className="input-wrapper">
            <label className="input-label">Adicionar nova tag</label>
            <input autoFocus={true} ref={input} className="input" type="text" placeholder="Nome da tag" onKeyDown={e => setKeyDownTerm(e)}
              onChange={e => setSearchTerm(e.target.value)} value={searchTerm} />
          </div>

          <div className="mt-20">
            {searchTags && searchTags.map((tag, index) => {
              return (
                <div key={index} className="tag-delete" onClick={() => handleAddExistingTagToCustomer(tag.id)}>
                  <div className="tag-delete-inner">
                    <span>#{tag.name}</span>
                  </div>
                </div>
              )
            })}
          </div>
          <div className="mt-20"></div>
          <Button title="Adicionar tag" type="submit" width="full" color="green" loading={loading} />
        </div>
      </form>
    </Popup>
  );
}